import request from "../http/index";
// import qs from "qs";


/**
 *
 * @param {*} data
 * @returns 登录
 */

export async function Login(data = {}) {
	const res = await request.post("/api/Login/Login", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 修改密码
 */

export async function ChangePass(data = {}) {
	const res = await request.post("/api/ua/UserInfo/ChangePass", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 重置密码
 */

export async function ChangePassWithoutLogin(data = {}) {
	const res = await request.post("/api/ua/UserInfo/ChangePassWithoutLogin", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 首页待处理预警
 */

export async function HomeRemindList(data = {}) {
	const res = await request.post("/api/helper/HomeRemind/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页待处理预警=>查看
 */

export async function HomeRemindSetHasView(data = {}) {
	const res = await request.post("/api/helper/HomeRemind/SetHasView", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页待处理预警=>版本信息
 */

export async function HomeRemindSystemVersion(data = {}) {
	const res = await request.post("/api/helper/HomeRemind/SystemVersion", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 菜单列表=>获取列表
 */

export async function MenuList(data = {}) {
	const res = await request.post("/api/ua/MenuList/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单管理=>新增
 */

export async function MenuListadd(data = {}) {
	const res = await request.post("/api/ua/MenuList/add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单管理=>详情
 */

export async function MenuListEdit(data = {}) {
	const res = await request.post("/api/ua/MenuList/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单管理=>修改
 */

export async function MenuListdetails(data = {}) {
	const res = await request.post("/api/ua/MenuList/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单管理=>删除
 */

export async function MenuListdel(data = {}) {
	const res = await request.post("/api/ua/MenuList/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单管理=>停用
 */

export async function MenuListSetEnable(data = {}) {
	const res = await request.post("/api/ua/MenuList/SetEnable", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>权限列表=>查询
 */

export async function AuthorityLists(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>权限列表=>新增
 */

export async function AuthorityListsAdd(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>权限列表=>详情
 */

export async function AuthorityListInfo(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>权限列表=>修改
 */

export async function Authoritydeit(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>权限列表=>删除
 */

export async function Authoritydel(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单权限=>获取菜单权限
 */

export async function MenuAuthority(data = {}) {
	const res = await request.post("/api/ua/MenuList/MenuAuthority", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>菜单权限=>修改菜单权限
 */

export async function SetMenuAuthority(data = {}) {
	const res = await request.post("/api/ua/MenuList/SetMenuAuthority", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>部门管理=>部门列表
 */

export async function OrganizationList(data = {}) {
	const res = await request.post("/api/ua/Organization/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>部门管理=>部门详情
 */

export async function OrganizationInfo(data = {}) {
	const res = await request.post("/api/ua/Organization/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>部门管理=>新增部门
 */

export async function OrganizationAdd(data = {}) {
	const res = await request.post("/api/ua/Organization/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>部门管理=>修改部门
 */

export async function OrganizationEdit(data = {}) {
	const res = await request.post("/api/ua/Organization/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 系统管理=>部门管理=>删除部门
 */

export async function OrganizationDelete(data = {}) {
	const res = await request.post("/api/ua/Organization/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>部门管理=>修改部门状态
 */

export async function OrganizationSetEnable(data = {}) {
	const res = await request.post("/api/ua/Organization/SetEnable", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>用户菜单列表
 */

export async function UserInfoMun(data = {}) {
	const res = await request.post("/api/ua/UserInfo/UserInfo", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>判断选择的用户是否可用【分配产品】 
 */

export async function UserInfoGetUserRole(data = {}) {
	const res = await request.post("/api/ua/UserInfo/GetUserRole", data);
	return res.data;
}

/** 
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>产品下拉列表   ​/api/ua/UserInfo/GetInvNameListByInvClass
 */

export async function UserInfoByInvClass(data = {}) {
	const res = await request.post("/api/ua/UserInfo/GetInvNameListByInvClass", data);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>添加用户产品/api​/ua​/UserInfo​/AddUserInventory
 */

export async function UserInfoAddUserInventory(data = {}) {
	const res = await request.post("/api/ua/UserInfo/AddUserInventory", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>用户列表
 */

export async function UserInfoList(data = {}) {
	const res = await request.post("/api/ua/UserInfo/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>用户详情
 */

export async function UserInfo(data = {}) {
	const res = await request.post("/api/ua/UserInfo/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>新增用户
 */

export async function UserInfoAdd(data = {}) {
	const res = await request.post("/api/ua/UserInfo/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>修改用户
 */

export async function UserInfoEdit(data = {}) {
	const res = await request.post("/api/ua/UserInfo/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>删除用户
 */

export async function UserInfoDelete(data = {}) {
	const res = await request.post("/api/ua/UserInfo/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>用户状态修改
 */

export async function UserInfoEnable(data = {}) {
	const res = await request.post("/api/ua/UserInfo/SetEnable", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>获取用户组织列表
 */

export async function GetUserCompany(data = {}) {
	const res = await request.post("/api/ua/UserInfo/GetUserCompany", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>角色列表
 */

export async function RolesList(data = {}) {
	const res = await request.post("/api/ua/Roles/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=> 获取用户产品线
 */

export async function GetUserInvClass(data = {}) {
	const res = await request.post("/api/ua/UserInfo/GetUserInvClass", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=> 设置用户产品线
 */
export async function SetUserInvClass(data = {}) {
	const res = await request.post("/api/ua/UserInfo/SetUserInvClass", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=> 导出
 */
export async function UserInfoExport(data = {}) {
	const res = await request.post("/api/ua/UserInfo/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>导入经销商账号
 */
export async function UserInfoImportCusUserName(data = {}) {
	const res = await request.post("/api/ua/UserInfo/ImportCusUserName", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>导入模板下载接口
 */
export async function UserInfoDownloadCusUserNameTemplet(data = {}) {
	const res = await request.post(
		"/api/ua/UserInfo/DownloadCusUserNameTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>导入用户接口
 */
export async function UserInfoImportUserInvClass(data = {}) {
	const res = await request.post("/api/ua/UserInfo/ImportUserInvClass", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>导入用户产品线模板下载接口
 */
export async function UserInfoDownloadUserInvClassTemplet(data = {}) {
	const res = await request.post(
		"/api/ua/UserInfo/DownloadUserInvClassTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>重置密码
 */
export async function UserInfoResetPassword(data = {}) {
	const res = await request.post("/api/ua/UserInfo/ResetPassword", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>导入
 */
export async function UserInfoImport(data = {}) {
	const res = await request.post("/api/ua/UserInfo/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户管理=>下载模板
 */
export async function UserInfoDownloadTemplet(data = {}) {
	const res = await request.post("/api/ua/UserInfo/DownloadTemplet", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 选中用户组织后，右侧组织下拉框选中当前的组织，然后调用接口
 */

export async function GetUserCompanyRoles(data = {}) {
	const res = await request.post("/api/ua/UserInfo/GetUserCompanyRoles", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 设置用户组织角色
 */

export async function SetUserCompanyRoles(data = {}) {
	const res = await request.post("/api/ua/UserInfo/SetUserCompanyRoles", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>查询列表
 */

export async function UserRolesList(data = {}) {
	const res = await request.post("/api/ua/Roles/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>详情
 */

export async function UserRolesInfo(data = {}) {
	const res = await request.post("/api/ua/Roles/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>修改
 */

export async function UserRolesEdit(data = {}) {
	const res = await request.post("/api/ua/Roles/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>新增
 */
export async function UserRolesAdd(data = {}) {
	const res = await request.post("/api/ua/Roles/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>新增
 */
export async function UserRolesDel(data = {}) {
	const res = await request.post("/api/ua/Roles/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>右侧列表
 */
export async function GetMenusWithAuthorites(data = {}) {
	const res = await request.post(
		"/api/ua/AuthorityList/GetMenusWithAuthorites",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>左侧列表
 */
export async function GetRoleUserList(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/GetRoleUserList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>下拉菜单
 */
export async function SearchList(data = {}) {
	const res = await request.post("/api/ua/MenuList/SearchList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>获取当前角色的当前权限列表
 */
export async function GetRoleUserAuthorities(data = {}) {
	const res = await request.post(
		"/api/ua/AuthorityList/GetRoleUserAuthorities",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>修改当前角色的当前权限列表
 */
export async function SetRoleUserAuthorities(data = {}) {
	const res = await request.post(
		"/api/ua/AuthorityList/SetRoleUserAuthorities",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>角色管理=>导出
 */
export async function AuthorityListExport(data = {}) {
	const res = await request.post("/api/ua/AuthorityList/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户登录操作
 */
export async function HelperUserLoginLogList(data = {}) {
	const res = await request.post("/api/report/Helper/UserLoginLogList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户登录操作 => 导出
 */
export async function HelperUserLoginLogExport(data = {}) {
	const res = await request.post("/api/report/Helper/UserLoginLogExport", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户登录操作=>列表 
 */
export async function HelperOperateLogList(data = {}) {
	const res = await request.post("/api/report/Helper/OperateLogList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 系统管理=>用户操作记录 => 导出
 */
export async function HelperOperateLogExport(data = {}) {
	const res = await request.post("/api/report/Helper/OperateLogExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线基础信息档案=>列表
 */
export async function ProductList(data = {}) {
	const res = await request.post("/api/ba/Product/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线基础信息档案=>新增
 */
export async function ProductAdd(data = {}) {
	const res = await request.post("/api/ba/Product/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线基础信息档案=>详情 
 */
export async function ProductInfo(data = {}) {
	const res = await request.post("/api/ba/Product/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线基础信息档案=>修改
 */
export async function ProductEdit(data = {}) {
	const res = await request.post("/api/ba/Product/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线基础信息档案=>删除
 */
export async function ProductDelete(data = {}) {
	const res = await request.post("/api/ba/Product/Delete", data);
	return res.data;
}
// /**
//  *
//  * @param {*} data
//  * @returns 基础档案管理=>产品=>产品档案=>导出
//  */
//  export async function InventorExport(data = {}) {
//   const res = await request.post("/api/ba/Inventory/Export", data, {
//     responseType: "blob",
//   });
//   return res.data;
// }
/**
 *
 * @param {*} data
 * @returns =>产品类别下拉
 */
export async function HelperInvType(data = {}) {
	const res = await request.post("/api/helper/Helper/InvType", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>列表 || 系统管理=>用户管理=>分配产品线
 */
export async function InventoryClassList(data = {}) {
	const res = await request.post("/api/ba/InventoryClass/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>详情
 */
export async function InventoryClassInfo(data = {}) {
	const res = await request.post("/api/ba/InventoryClass/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>新增
 */
export async function InventoryClassAdd(data = {}) {
	const res = await request.post("/api/ba/InventoryClass/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>修改
 */
export async function InventoryClassEdit(data = {}) {
	const res = await request.post("/api/ba/InventoryClass/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>删除
 */
export async function InventoryClassDelete(data = {}) {
	const res = await request.post("/api/ba/InventoryClass/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>导入
 */
export async function InventoryImport(data = {}) {
	const res = await request.post("/api/ba/Inventory/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品线档案=>导入模板
 */
export async function InventoryDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/Inventory/DownloadTemplet", data);
	return res.data;
}
//产品

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>列表
 */
export async function InventoryList(data = {}) {
	const res = await request.post("/api/ba/Inventory/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>详情
 */
export async function InventoryInfo(data = {}) {
	const res = await request.post("/api/ba/Inventory/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>新增
 */
export async function InventoryAdd(data = {}) {
	const res = await request.post("/api/ba/Inventory/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>修改
 */
export async function InventoryEdit(data = {}) {
	const res = await request.post("/api/ba/Inventory/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>删除
 */
export async function InventoryDelete(data = {}) {
	const res = await request.post("/api/ba/Inventory/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>停用
 */
export async function InventoryActive(data = {}) {
	const res = await request.post("/api/ba/Inventory/Active", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品档案=>启用
 */
export async function InventoryDeActive(data = {}) {
	const res = await request.post("/api/ba/Inventory/DeActive", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>产品=>产品档案=>导出
 */
export async function InventorExport(data = {}) {
	const res = await request.post("/api/ba/Inventory/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>列表 || 父级编码下拉框
 */
export async function BaOrganizationList(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>详情
 */
export async function BaOrganizationInfo(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>新增
 */
export async function BaOrganizationAdd(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>修改
 */
export async function BaOrganizationEdit(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>删除
 */
export async function BaOrganizationDelete(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>启停用
 */
export async function BaOrganizationSetActive(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/SetActive", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>证照驳回
 */
export async function OpenAccountReject(data = {}) {
	const res = await request.post("/api/ba/OpenAccount/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>查看证照
 */
export async function LicenseGetAllLicense(data = {}) {
	const res = await request.post("/api/ba/License/GetAllLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>驳回列表
 */
export async function LicenseGetRejectLicense(data = {}) {
	const res = await request.post("/api/ba/License/GetRejectLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>营业执照驳回明细
 */
export async function LicenseGetBusinessLicense(data = {}) {
	const res = await request.post("/api/ba/License/GetBusinessLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>医疗器械经营许可证
 */
export async function LicenseGetBusinessPermission(data = {}) {
	const res = await request.post("/api/ba/License/GetBusinessPermission", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>第二类医疗器械备案凭证
 */
export async function LicenseGetBusinessRecord(data = {}) {
	const res = await request.post("/api/ba/License/GetBusinessRecord", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>营业执照驳回
 */
export async function LicenseRejectBusinessLicense(data = {}) {
	const res = await request.post("/api/ba/License/RejectBusinessLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>医疗器械经营许可证驳回
 */
export async function LicenseRejectBusinessPermission(data = {}) {
	const res = await request.post("/api/ba/License/RejectBusinessPermission", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>第二类医疗器械备案凭证驳回
 */
export async function LicenseRejectBusinessRecord(data = {}) {
	const res = await request.post("/api/ba/License/RejectBusinessRecord", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>全部通过
 */
export async function LicenseVerifyLicense(data = {}) {
	const res = await request.post("/api/ba/License/VerifyLicense", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>一级经销商U8配置（展示）
 */
export async function BaOrganizationU8MatchList(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/U8MatchList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>一级经销商U8配置（新增）
 */
export async function BaOrganizationAddU8Match(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/AddU8Match", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>一级经销商U8配置（删除）
 */
export async function BaOrganizationDeleteU8Match(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/DeleteU8Match", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>下载一级经销商U8配置导入模板
 */
export async function BaOrganizationDownloadU8MatchTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/BaOrganization/DownloadU8MatchTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>一级经销商档案=>一级经销商U8配置导入
 */
export async function BaOrganizationImportU8Match(data = {}) {
	const res = await request.post("/api/ba/BaOrganization/ImportU8Match", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>列表
 */
export async function CustomerList(data = {}) {
	const res = await request.post("/api/ba/Customer/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>客户类型下拉
 */
export async function GetCusType(data = {}) {
	const res = await request.get("/api/ba/Customer/GetCusType", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>详情
 */
export async function CustomerInfo(data = {}) {
	const res = await request.post("/api/ba/Customer/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>新增
 */
export async function CustomerAdd(data = {}) {
	const res = await request.post("/api/ba/Customer/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>修改
 */
export async function CustomerEdit(data = {}) {
	const res = await request.post("/api/ba/Customer/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>删除
 */
export async function CustomerDelete(data = {}) {
	const res = await request.post("/api/ba/Customer/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>启停用
 */
export async function BCustomerSetActive(data = {}) {
	const res = await request.post("/api/ba/Customer/SetActive", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>导出
 */
export async function CustomerExport(data = {}) {
	const res = await request.post("/api/ba/Customer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>导入
 */
export async function CustomerImport(data = {}) {
	const res = await request.post("/api/ba/Customer/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>导入模板
 */
export async function CustomerDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/Customer/DownloadTemplet", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>二级经销商U8配置（展示）
 */
export async function CustomerU8MatchList(data = {}) {
	const res = await request.post("/api/ba/Customer/U8MatchList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>二级经销商U8配置（新增）
 */
export async function CustomerAddU8Match(data = {}) {
	const res = await request.post("/api/ba/Customer/AddU8Match", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>二级经销商U8配置（删除）
 */
export async function CustomerDeleteU8Match(data = {}) {
	const res = await request.post("/api/ba/Customer/DeleteU8Match", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>二级经销商U8配置（删除）
 */
export async function CustomerDownloadU8MatchTemplet(data = {}) {
	const res = await request.post(
		"api/ba/Customer/DownloadU8MatchTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>经销商=>二级经销商档案=>二级经销商U8配置导入
 */
export async function CustomerImportU8Match(data = {}) {
	const res = await request.post("/api/ba/Customer/ImportU8Match", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>生产厂家档案=>列表
 */
export async function ManufacturerList(data = {}) {
	const res = await request.post("/api/ba/Manufacturer/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>生产厂家档案=>详情
 */
export async function ManufacturerInfo(data = {}) {
	const res = await request.post("/api/ba/Manufacturer/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>生产厂家档案=>导出
 */
export async function ManufacturerExport(data = {}) {
	const res = await request.post("/api/ba/Manufacturer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>生产厂家档案=>新增
 */
export async function ManufacturerAdd(data = {}) {
	const res = await request.post("/api/ba/Manufacturer/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>生产厂家档案=>修改
 */
export async function ManufacturerEdit(data = {}) {
	const res = await request.post("/api/ba/Manufacturer/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>生产厂家档案=>删除
 */
export async function ManufacturerDelete(data = {}) {
	const res = await request.post("/api/ba/Manufacturer/Delete", data);
	return res.data;
}
// 医院
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>增加客户等级下拉框
 */
export async function HelperHosGrade(data = {}) {
	const res = await request.get("/api/helper/Helper/HosGrade", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>医院列表
 */
export async function HosProcessList(data = {}) {
	const res = await request.post("/api/ba/Hospital/HosProcessList", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>列表
 */
export async function HospitalList(data = {}) {
	const res = await request.post("/api/ba/Hospital/List", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>合并医院
 */
export async function UnionHospital(data = {}) {
	const res = await request.post("/api/ba/Hospital/UnionHospital", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>详情
 */
export async function HospitalInfo(data = {}) {
	const res = await request.post("/api/ba/Hospital/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>新增
 */
export async function HospitalAdd(data = {}) {
	const res = await request.post("/api/ba/Hospital/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>修改
 */
export async function HospitalEdit(data = {}) {
	const res = await request.post("/api/ba/Hospital/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>删除
 */
export async function HospitalDelete(data = {}) {
	const res = await request.post("/api/ba/Hospital/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>导出
 */
export async function HospitalExport(data = {}) {
	const res = await request.post("/api/ba/Hospital/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>导出
 */
export async function HosProcessExport(data = {}) {
	const res = await request.post("/api/ba/Hospital/HosProcessExport", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>医院分类
 */
export async function GetHospitalType(data = {}) {
	const res = await request.get("api/ba/Hospital/GetHospitalType", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>导入
 */
export async function HospitalImport(data = {}) {
	const res = await request.post("/api/ba/Hospital/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>导入模板
 */
export async function HospitalDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/Hospital/DownloadTemplet", data);
	return res.data;
}
export async function GetHospitalTypeList(data = {}) {
	const res = await request.get("/api/ba/Hospital/GetHospitalTypeList", data);
	return res.data;
}
export async function EditHospitalType(data = {}) {
	const res = await request.post("/api/ba/Hospital/EditHospitalType", data);
	return res.data;
}
export async function DelHospitalType(data = {}) {
	const res = await request.post("/api/ba/Hospital/DelHospitalType", data);
	return res.data;
}
export async function DownloadHospitalTypeTemplet(data = {}) {
	const res = await request.post("/api/ba/Hospital/DownloadHospitalTypeTemplet", data);
	return res.data;
}
export async function ImportHospitalType(data = {}) {
	const res = await request.post("/api/ba/Hospital/ImportHospitalType", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>医院档案=>医院下拉
 */
export async function HospitalGetHospitalType(data = {}) {
	const res = await request.get("/api/ba/Hospital/GetHospitalType", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>仓库档案=>列表
 */
export async function WarehouseList(data = {}) {
	const res = await request.post("/api/ba/Warehouse/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>备案信息审批=>查看
 */
export async function APPRelationProviderInfo(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>备案信息审批=>列表
 */
export async function AppRelationProviderApprove(data = {}) {
	const res = await request.post("/api/ba/AppRelationProvider/Approve", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>备案信息审批=>驳回
 */

export async function APPRelationProviderReject(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>备案信息审批=>审批流程
 */

export async function APPRelationProviderGetHostory(data = {}) {
	const res = await request.post("/api/ba/APPRelationProvider/GetHostory", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 计量单位下拉
 */
export async function HelperComUnit(data = {}) {
	const res = await request.get("/api/helper/Helper/ComUnit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>仓库档案=>列表
 */
export async function WarehouseInfo(data = {}) {
	const res = await request.post("/api/ba/Warehouse/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>仓库档案=>新增
 */
export async function WarehouseAdd(data = {}) {
	const res = await request.post("/api/ba/Warehouse/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>仓库档案=>修改
 */
export async function WarehouseEdit(data = {}) {
	const res = await request.post("/api/ba/Warehouse/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>仓库档案=>删除
 */
export async function WarehouseDelete(data = {}) {
	const res = await request.post("/api/ba/Warehouse/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>列表
 */
export async function CustomerQuotaList(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>详情
 */
export async function CustomerQuotaInfo(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>新增
 */
export async function CustomerQuotaAdd(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>修改
 */
export async function CustomerQuotaEdit(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>删除
 */
export async function CustomerQuotaDelete(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>全部删除
 */
export async function CustomerQuotaDeleteAll(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/DeleteAll", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>导入
 */
export async function CustomerQuotaImport(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>导出
 */
export async function CustomerQuotaExport(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>导入模板下载
 */
export async function CustomerQuotaDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/DownloadTemplet", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院指标维护=>下载省市区列表信息
 */
export async function CustomeDownloadAreaListr(data = {}) {
	const res = await request.post("/api/ba/Customer/DownloadAreaList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员医院关系=>列表
 */
export async function CusRelationHospitalList(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/List", data);
	return res.data;
}

export async function HelperTechnicalOfficesList(data = {}) {
	const res = await request.post("/api/helper/Helper/TechnicalOfficesList", data);
	return res.data;
}

export async function TechnicalOfficesList(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员医院关系=>详情
 */
export async function CusRelationHospitalInfo(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员=>导出
 */
export async function PersonGradationExport(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/Export", data, {
		responseType: "blob",
	});
	return res;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员医院关系=>新增
 */
export async function CusRelationHospitalAdd(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员医院关系=>修改
 */
export async function CusRelationHospitalEdit(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员医院关系=>导出
 */
export async function CusRelationHospitalExport(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/Export", data, {
		responseType: "blob",
	});
	return res;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员医院关系=>业务员
 */
export async function CusRelationUserInfoList(data = {}) {
	const res = await request.post("/api/ua/UserInfo/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院业务员关系=>删除
 */
export async function CusRelationHospitalDelete(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员关系=>删除
 */
export async function PersonGradationDelete(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院业务员关系=>导入模板下载
 */
export async function CusRelationDownloadTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationHospital/DownloadTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商医院业务员关系=>导入
 */
export async function CusRelationHospitalImport(data = {}) {
	const res = await request.post("/api/ba/CusRelationHospital/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员等级=>树状列表
 */
export async function PersonGradationList(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员等级=>详情
 */
export async function PersonGradationInfo(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员等级=>新增
 */
export async function PersonGradationAdd(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员等级=>修改
 */
export async function PersonGradationEdit(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>业务员等级=>获取树末级
 */
export async function PersonGradationGetMaxGrade(data = {}) {
	const res = await request.post("/api/ba/PersonGradation/GetMaxGrade", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>列表
 */
export async function CusRelationProviderList(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>查看
 */
export async function CusRelationProviderInfo(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>新增
 */
export async function CusRelationProviderAdd(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>修改
 */
export async function CusRelationProviderEdit(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>删除
 */
export async function CusRelationProviderDelete(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>驳回
 */
export async function CusRelationProviderReject(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>启用
 */
export async function CusRelationProviderActive(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Active", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>停用
 */
export async function CusRelationProviderDeActive(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/DeActive", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>查看图片
 */
export async function CusRelationProviderGetInvoicePic(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/GetImages", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>经销商_服务商_医院备案=>导入
 */
export async function CusRelationProviderImport(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>经销商_服务商_医院备案=>导出
 */
export async function CusRelationProviderExport(data = {}) {
	const res = await request.post("/api/ba/CusRelationProvider/Export", data, {
		responseType: "blob",
	});
	return res;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>经销商_服务商_医院备案=>上传图片
 */
export async function CusRelationProviderUploadSalesInvListPic(data = {}, ID) {
	const res = await request.post(
		"/api/ba/CusRelationProvider/UploadImage?ID=" + ID,
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>经销商_服务商_医院备案=>编辑界面上传图片
 */
export async function CusRelationProviderUploadSalesInvListByEdit(data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationProvider/UploadImageByEdit",
		data, {
			headers: {
				"Content-Type": "multipart/form-data;"
			},
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>经销商_服务商_医院备案=>导入下载模板
 */
export async function CusRelationProviderDownloadTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationProvider/DownloadTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>列表
 */
export async function InvStandardCostList(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>新增
 */
export async function InvStandardCostAdd(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>修改
 */
export async function InvStandardCostEdit(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>修改
 */
export async function InvStandardCostInfo(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>删除
 */
export async function InvStandardCostDelete(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>启用
 */
export async function InvStandardCostActive(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Active", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理=>业务=>产品标注货值档案=>停用
 */
export async function InvStandardCostDeActive(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/DeActive", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>产品标注货值档案=>导入
 */
export async function InvStandardCostImport(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>产品标注货值档案=>导出
 */
export async function InvStandardCostExport(data = {}) {
	const res = await request.post("/api/ba/InvStandardCost/Export", data, {
		responseType: "blob",
	});
	return res;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>产品标注货值档案=>导入模板下载地址
 */
export async function InvStandardCostDownloadTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/InvStandardCost/DownloadTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>列表
 */
export async function AsnList(data = {}) {
	const res = await request.post("/api/wms/ASN/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>详情
 */
export async function AsnInfo(data = {}) {
	const res = await request.post("/api/wms/ASN/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>删除
 */
export async function AsnDelete(data = {}) {
	const res = await request.post("/api/wms/ASN/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>审核
 */
export async function AsnVerify(data = {}) {
	const res = await request.post("/api/wms/ASN/Verify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>弃审
 */
export async function AsnUnVerify(data = {}) {
	const res = await request.post("/api/wms/ASN/UnVerify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>明细
 */
export async function AsnDetail(data = {}) {
	const res = await request.post("/api/wms/ASN/Detail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>唯一码明细
 */
export async function AsnUnique(data = {}) {
	const res = await request.post("/api/wms/ASN/DetailUnique", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>导出
 */
export async function AsnExpost(data = {}) {
	const res = await request.post("/api/wms/ASN/Export", data, {
		responseType: "blob",
	});
	return res;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>经销商名称下拉
 */
export async function CusType(data = {}) {
	const res = await request.get("/api/ua/UserInfo/CusType", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>单据类型下拉
 */
export async function ASNVoucherType(data = {}) {
	const res = await request.get("/api/helper/Helper/ASNVoucherType", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>单据类型下拉(仅限出库)
 */
export async function HelperDPVoucherType(data = {}) {
	const res = await request.get("/api/helper/Helper/DPVoucherType", data);
	return res.data;
}

export async function HelperDPVoucherTypeForEdit(data = {}) {
	const res = await request.get("/api/helper/Helper/DPVoucherTypeForEdit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>状态下拉
 */
export async function Status(data = {}) {
	const res = await request.get("/api/helper/Helper/Status", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>导入
 */
export async function Import(data = {}) {
	const res = await request.post("/api/wms/ASN/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>下载模板
 */
export async function DownloadTemplet(data = {}) {
	const res = await request.post("/api/wms/ASN/DownloadTemplet", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>入库唯一码导出
 */
export async function UniqueExportForEdit(data = {}) {
	const res = await request.post("/api/wms/ASN/UniqueExportForEdit", data, {
		responseType: "blob",
	});
	return res;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>入库上报管理（同【入库单列表】）=>修改保存
 */
export async function ASNEdit(data = {}) {
	const res = await request.post("/api/wms/ASN/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【出库单列表】）=>列表
 */
export async function wmsDespatchList(data = {}) {
	const res = await request.post("/api/wms/Despatch/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【出库单列表】）=>详情
 */
export async function wmsDespatchInfo(data = {}) {
	const res = await request.post("/api/wms/Despatch/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【出库单列表】）=>明细
 */
export async function wmsDespatchDetail(data = {}) {
	const res = await request.post("/api/wms/Despatch/Detail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【出库单列表】）=>唯一码
 */
export async function wmsDespatchDetailUnique(data = {}) {
	const res = await request.post("/api/wms/Despatch/DetailUnique", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【出库单列表】）=>删除
 */
export async function wmsDespatchDelete(data = {}) {
	const res = await request.post("/api/wms/Despatch/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>审核
 */
export async function wmsDespatchVerify(data = {}) {
	const res = await request.post("/api/wms/Despatch/Verify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>弃审
 */
export async function wmsDespatchUnVerify(data = {}) {
	const res = await request.post("/api/wms/Despatch/UnVerify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>导出
 */
export async function wmsDespatchExport(data = {}) {
	const res = await request.post("/api/wms/Despatch/Export", data, {
		responseType: "blob",
	});
	return res;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>导入
 */
export async function wmsDespatchImport(data = {}) {
	const res = await request.post("/api/wms/Despatch/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>商品列表
 */
export async function StockReportList(data = {}) {
	const res = await request.post("/api/WMS/StockReport/StockList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>上传出库明细
 */
export async function DespatchImportDetail(data = {}) {
	const res = await request.post("/api/wms/Despatch/ImportDetail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>出库单据明细导入模板下载地址链接
 */
export async function DespatchDownloadDetailTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/Despatch/DownloadDetailTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>出库单据明细导入模板下载地址链接【编辑】
 */
export async function DespatchDownloadTemplet(data = {}) {
	const res = await request.post("/api/wms/Despatch/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>上传出入库唯一码明细
 */
export async function DespatchImportUnique(data = {}) {
	const res = await request.post("/api/wms/Despatch/ImportUnique", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>出库单据明细导入模板下载地址链接
 */
export async function DespatchDownloadUniqueTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/Despatch/DownloadUniqueTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>新增
 */
export async function DespatchAdd(data = {}) {
	const res = await request.post("/api/wms/Despatch/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>修改
 */
export async function DespatchEdit(data = {}) {
	const res = await request.post("/api/wms/Despatch/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>出库上报管理（同【>出库单列表】）=>出库扫描唯一码
 */
export async function StockReportUniqueInfo(data = {}) {
	const res = await request.post("/api/wms/StockReport/UniqueInfo", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>列表
 */
export async function TransVouchList(data = {}) {
	const res = await request.post("/api/wms/TransVouch/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>详情
 */
export async function TransVouchInfo(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>明细
 */
export async function TransVouchDetail(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Detail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>唯一码明细
 */
export async function TransVouchDetailUnique(data = {}) {
	const res = await request.post("/api/wms/TransVouch/DetailUnique", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>删除
 */
export async function TransVouchDelete(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>审核
 */
export async function TransVouchVerify(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Verify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>弃审
 */
export async function TransVouchUnVerify(data = {}) {
	const res = await request.post("/api/wms/TransVouch/UnVerify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>变更
 */
export async function TransVouchChangeCustomerByTV(data = {}) {
	const res = await request.post(
		"/api/wms/TransVouch/ChangeCustomerByTV",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>导出
 */
export async function TransVouchExport(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Export", data, {
		responseType: "blob",
	});
	return res;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>导入
 */
export async function TransVouchImport(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>下载导入模板
 */
export async function TransVouchDownloadTemplet(data = {}) {
	const res = await request.post("/api/wms/TransVouch/DownloadTemplet", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>单据编辑明细导入模板下载地址链接
 */
export async function TransVouchDownloadDetailTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/TransVouch/DownloadDetailTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>单据编辑唯一码导入模板下载地址链接
 */
export async function TransVouchDownloadUniqueTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/TransVouch/DownloadUniqueTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>导入调拨明细
 */
export async function TransVouchImportDetail(data = {}) {
	const res = await request.post("/api/wms/TransVouch/ImportDetail", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>导入调拨唯一码明细
 */
export async function TransVouchImportUnique(data = {}) {
	const res = await request.post("/api/wms/TransVouch/ImportUnique", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>新增保存
 */
export async function TransVouchAdd(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>调拨管理展示=>编辑保存
 */
export async function TransVouchEdit(data = {}) {
	const res = await request.post("/api/wms/TransVouch/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>列表
 */
export async function SaleBillList(data = {}) {
	const res = await request.post("/api/sms/SaleBill/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>详情
 */
export async function SaleBillInfo(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>删除
 */
export async function SaleBillDelete(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>审核
 */
export async function SaleBillVerify(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Verify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>弃审
 */
export async function SaleBillUnVerify(data = {}) {
	const res = await request.post("/api/sms/SaleBill/UnVerify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>明细
 */
export async function SaleBillDetail(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Detail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管=>发票照片明细
 */
export async function SaleBillDetailUnique(data = {}) {
	const res = await request.post("/api/sms/SaleBill/GetInvoicePic", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns IMS销售报表=>显示发票
 */
export async function GetInvoiceImage(data = {}) {
	const res = await request.post("/api/sms/SaleBill/GetInvoiceImage", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>导出
 */
export async function SaleBillExport(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Export", data, {
		responseType: "blob",
	});
	return res;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>导入
 */
export async function SaleBillImport(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>下载导入模板
 */
export async function SaleBillDownloadTemplet(data = {}) {
	const res = await request.post("/api/sms/SaleBill/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>单据类型下拉
 */
export async function HelperDPhVoucherType(data = {}) {
	const res = await request.post("/api/helper/Helper/DPhVoucherType", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票类型下拉
 */
export async function HelperCheckWay(data = {}) {
	const res = await request.get("/api/helper/Helper/CheckWay", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票校验状态
 */
export async function HelperInvoiceChecked(data = {}) {
	const res = await request.get("/api/helper/Helper/InvoiceChecked", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>打包下载发票照片
 */
export async function SaleBillBatchDownloadInvoicePic(data = {}) {
	const res = await request.post("/api/sms/SaleBill/BatchDownloadInvoicePic", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>
 */
export async function SaleBillUploadInvoicePic(data = {}) {
	const res = await request.post("/api/sms/SaleBill/UploadInvoicePic", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>上传销货清单（新增按钮）
 */
export async function SaleBillUploadSalesInvListPic(data = {}, SBMID) {
	const res = await request.post(
		"/api/sms/SaleBill/UploadSalesInvListPic?SBMID=" + SBMID,
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>销货清单图片上传
 */
export async function SaleBillUploadSalesInvListByEdit(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/UploadSalesInvListByEdit",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>销货清单图片删除
 */
export async function SaleBillDeleteInvListImg(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/DeleteInvListImg",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>出库单列表
 */
export async function despatchList(data = {}) {
	const res = await request.post("/api/wms/despatch/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票上报修改列表
 */
export async function DespatchDetailByDPMIDs(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/DespatchDetailByDPMIDs",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票照片上传
 */
export async function SaleBillUploadInvoicePicByEdit(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/UploadInvoicePicByEdit",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>四要素效验
 */
export async function SaleBillCheckInvoicePicByStandard(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/CheckInvoicePicByStandard",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票内容校验
 */
export async function SaleBillCheckInvoiceDetail(data = {}) {
	const res = await request.post("/api/sms/SaleBill/CheckInvoiceDetail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>(增加)保存
 */
export async function SaleBillAdd(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>(修改)保存
 */
export async function SaleBillEdit(data = {}) {
	const res = await request.post("/api/sms/SaleBill/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票标注
 */
export async function SaleBillDoInvoiceCheckedChange(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/DoInvoiceCheckedChange",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>发票标注2
 */
export async function SaleBillDoMultiInvoiceCheckedChange(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/DoMultiInvoiceCheckedChange",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>发票管理=>发票上报管理=>变更终端医院
 */
export async function SaleBillChangeTerminalHospital(data = {}) {
	const res = await request.post(
		"/api/sms/SaleBill/ChangeTerminalHospital",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>入院进度报表=>列表 
 */
export async function BAReportProcessList(data = {}) {
	const res = await request.post("/api/report/BAReport/ProcessList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>入院进度报表=>导出
 */
export async function BAReportExportProcessList(data = {}) {
	const res = await request.post("/api/report/BAReport/ExportProcessList", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>销售出库未开票报表=>列表
 */
export async function WMSReportDespatchUnBillReportList(data = {}) {
	const res = await request.post("/api/report/WMSReport/DespatchUnBillReportList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>销售出库未开票报表=>导出
 */
export async function WMSReportDespatchUnBillReportExport(data = {}) {
	const res = await request.post("/api/report/WMSReport/DespatchUnBillReportExport", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>IMS销量=>列表 
 */
export async function SMSReportIMSSalesList(data = {}) {
	const res = await request.post("/api/report/SMSReport/IMSSalesList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>IMS销量=>导出
 */
export async function SMSReportIMSSalesExport(data = {}) {
	const res = await request.post("/api/report/SMSReport/IMSSalesExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表=>存库列表=>列表
 */
export async function StockReportStockList(data = {}) {
	const res = await request.post("/api/WMS/StockReport/StockList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>存库列表=>修改
 */
export async function StockReportEdit(data = {}) {
	const res = await request.post("/api/WMS/StockReport/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>存库列表=>导出
 */
export async function StockReportStockExport(data = {}) {
	const res = await request.post("/api/WMS/StockReport/StockExport", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>存库列表=>导出库存天数
 */
export async function StockReportStockDayExport(data = {}) {
	const res = await request.post("/api/report/WMSReport/StockPivotTableByCostForExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表=>存库列表=>库存汇总
 */
export async function StockPivotTableByCost(data = {}) {
	const res = await request.post("/api/report/WMSReport/StockPivotTableByCost", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表=>U8出库单=>列表
 */
export async function U8ReportU8RDReportList(data = {}) {
	const res = await request.post("/api/report/U8Report/U8RDReportList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8出库单=>导出
 */
export async function U8ReportU8RDReportExport(data = {}) {
	const res = await request.post(
		"/api/report/U8Report/U8RDReportExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>经销商采购入库报表=>列表
 */
export async function WMSReportASNReportList(data = {}) {
	const res = await request.post("/api/report/WMSReport/ASNReportList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>经销商采购入库报表=>导出
 */
export async function WMSReportASNReportExport(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/ASNReportExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>经销商采购出库报表=>列表
 */
export async function WMSReportDespatchReportList(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/DespatchReportList",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>经销商采购出库报表=>导出
 */
export async function WMSReportDespatchReportExport(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/DespatchReportExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8销售订单=>列表
 */
export async function U8ReportU8SOReportList(data = {}) {
	const res = await request.post("/api/report/U8Report/U8SOReportList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8销售订单=>导出
 */
export async function U8ReportU8SOReportExport(data = {}) {
	const res = await request.post(
		"/api/report/U8Report/U8SOReportExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8发货订单列表=>列表
 */
export async function U8ReportU8DLReportList(data = {}) {
	const res = await request.post("/api/report/U8Report/U8DLReportList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8发货订单列表=>导出
 */
export async function U8ReportU8DLReportExport(data = {}) {
	const res = await request.post(
		"/api/report/U8Report/U8DLReportExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8账套下拉框获取
 */
export async function HelperU8AccId(data = {}) {
	const res = await request.get("/api/helper/Helper/U8AccId", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表=>U8状态下拉框
 */
export async function HelperU9Status(data = {}) {
	const res = await request.get("/api/helper/Helper/U9Status", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表=>经销商达成率报表=>列表
 */
export async function SMSReportList(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/CustomerQuotaList",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>经销商达成率报表=>导出
 */
export async function SMSReportCustomerQuotaExport(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/CustomerQuotaExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表=>唯一码库存列表展示=>列表
 */
export async function StockReportUniqueStockList(data = {}) {
	const res = await request.post("/api/WMS/StockReport/UniqueStockList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>唯一码库存列表展示=>导出
 */
export async function StockReportUniqueStockExport(data = {}) {
	const res = await request.post(
		"/api/WMS/StockReport/UniqueStockExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8现存量报表=>列表
 */
export async function U8ReportU8CSReportList(data = {}) {
	const res = await request.post("/api/report/U8Report/U8CSReportList", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8现存量报表=>导出
 */
export async function U8ReportU8CSReportExport(data = {}) {
	const res = await request.post(
		"/api/report/U8Report/U8CSReportExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>U8现存量报表=>仓库下拉框
 */
export async function HelperU8Warehouse(data = {}, cAccId) {
	const res = await request.get(
		"/api/helper/Helper/U8Warehouse?cAccId=" + cAccId,
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>收发存汇总表=>列表
 */
export async function WMSReportTransceiversSummaryList(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/TransceiversSummaryList",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>收发存汇总表=>导出
 */
export async function WMSReportTransceiversSummaryExport(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/TransceiversSummaryExport",
		data, {
			responseType: "blob",
		}
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>U8接口管理报表展示=>列表
 */
export async function U8SynchronousList(data = {}) {
	const res = await request.post("/api/helper/U8Synchronous/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>U8接口管理报表展示=>查看
 */
export async function U8SynchronousEdit(data = {}) {
	const res = await request.post("/api/helper/U8Synchronous/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>U8接口管理报表展示=>重置
 */
export async function U8SynchronousdoReset(data = {}) {
	const res = await request.post("/api/helper/U8Synchronous/doReset", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>U8接口管理报表展示=>跳过
 */
export async function U8SynchronousDoSkip(data = {}) {
	const res = await request.post("/api/helper/U8Synchronous/DoSkip", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>U8接口管理报表展示=>U8接口类型
 */
export async function HelperU8MethodName(data = {}) {
	const res = await request.get("/api/helper/Helper/U8MethodName", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>U8接口管理报表展示=>U8接口状态
 */
export async function HelperU8InterfaceStatus(data = {}) {
	const res = await request.get("/api/helper/Helper/U8InterfaceStatus", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>发票二次校验=>列表
 */
export async function Check2InvoiceList(data = {}) {
	const res = await request.post("/api/helper/Check2Invoice/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 接口管理=>发票二次校验=>查看
 */
export async function Check2InvoiceEdit(data = {}) {
	const res = await request.post("/api/helper/Check2Invoice/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>发票二次校验=>导出
 */
export async function Check2InvoiceExport(data = {}) {
	const res = await request.post("/api/helper/Check2Invoice/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>发票二次校验=>二次校验
 */
export async function Check2InvoiceInvoice(data = {}) {
	const res = await request.post("/api/helper/Check2Invoice/Invoice", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>发票二次校验=>三次校验
 */
export async function Check3InvoiceInvoice(data = {}) {
	const res = await request.post("/api/helper/Check2Invoice/Invoice3", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>发票二次校验=>四次校验
 */
export async function Check4InvoiceInvoice(data = {}) {
	const res = await request.post("/api/helper/Check2Invoice/Invoice4", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>票查查校验=>图片
 */
export async function HelperCheckInvoiceDemo(data = {}) {
	const res = await request.post("/api/helper/Helper/CheckInvoiceDemo", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 报表=>票查查校验=>四要素
 */
export async function HelperCheckInvoiceDemoByStandard(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/CheckInvoiceDemoByStandard",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>发送用户下拉
 */
export async function HelperGetUserNameAndRole(data = {}) {
	const res = await request.post(
		"/api/helper/Helper/GetUserNameAndRole",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>上传附件
 */
export async function InformationUpLoadAttachment(data = {}) {
	const res = await request.post(
		"/api/cp/Information/UpLoadAttachment",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>发布新的资讯
 */
export async function InformationAdd(data = {}) {
	const res = await request.post(
		"/api/cp/Information/Add",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>修改资讯
 */
export async function InformationEdit(data = {}) {
	const res = await request.post(
		"/api/cp/Information/Edit",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>详情资讯
 */
export async function InformationInfo(data = {}) {
	const res = await request.post(
		"/api/cp/Information/Info",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>删除资讯
 */
export async function InformationDelete(data = {}) {
	const res = await request.post(
		"/api/cp/Information/Delete",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>资讯列表
 */
export async function InformationList(data = {}) {
	const res = await request.post(
		"/api/cp/Information/List",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>资讯发布管理=>发布人
 */
export async function InformationGetCreatorList(data = {}) {
	const res = await request.post(
		"/api/cp/Information/GetCreatorList",
		data
	);
	return res.data;
}

/** 
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>上传附件
 */
export async function ComplianceUpLoadAttachment(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/UpLoadAttachment",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>发布新的合规培训
 */
export async function ComplianceAdd(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/Add",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>修改合规培训
 */
export async function ComplianceEdit(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/Edit",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>详情合规培训
 */
export async function ComplianceInfo(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/Info",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>删除合规培训
 */
export async function ComplianceDelete(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/Delete",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>合规培训列表
 */
export async function ComplianceList(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/List",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>合规培训发布管理=>发布人
 */
export async function ComplianceGetCreatorList(data = {}) {
	const res = await request.post(
		"/api/cp/Compliance/GetCreatorList",
		data
	);
	return res.data;
}

/** 
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>上传附件
 */
export async function NotificationUpLoadAttachment(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/UpLoadAttachment",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>发布新的通知函
 */
export async function NotificationAdd(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/Add",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>修改通知函
 */
export async function NotificationEdit(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/Edit",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>详情通知函
 */
export async function NotificationInfo(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/Info",
		data
	);
	return res.data;
}
/** 
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>删除通知函
 */
export async function NotificationDelete(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/Delete",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>通知函列表
 */
export async function NotificationList(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/List",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>通知函发布管理=>发布人
 */
export async function NotificationGetCreatorList(data = {}) {
	const res = await request.post(
		"/api/cp/Notification/GetCreatorList",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 首页管理=>Banner管理=>列表
 */
export async function BannerList(data = {}) {
	const res = await request.post(
		"/api/cp/Banner/List",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>Banner管理=>新增
 */
export async function BannerAdd(data = {}) {
	const res = await request.post(
		"/api/cp/Banner/Add",
		data
	);
	return res.data;
}
/**
 * 
 * @param {*} data
 * @returns 首页管理=>Banner管理=>修改
 */
export async function BannerEdit(data = {}) {
	const res = await request.post(
		"/api/cp/Banner/Edit",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页管理=>Banner管理=>删除
 */
export async function BannerDelete(data = {}) {
	const res = await request.post(
		"/api/cp/Banner/Delete",
		data
	);
	return res.data;
}
/**
 *  
 * @param {*} data
 * @returns 首页管理=>Banner管理=>详情
 */
export async function BannerInfo(data = {}) {
	const res = await request.post(
		"/api/cp/Banner/Info",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  首页管理=>Banner管理=>上传Banner
 */

export async function BannerUpLoadAttachment(data = {}) {
	const res = await request.post("/api/cp/Banner/UpLoadAttachment", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 省
 */
export async function GetProvince(data = {}) {
	const res = await request.get("/api/helper/Region/GetProvince", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 市
 */
export async function GetCity(params = {}) {
	const res = await request.get("/api/helper/Region/GetCity", params);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 区
 */
export async function GetDistrict(data = {}) {
	const res = await request.get("/api/helper/Region/GetDistrict", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 填写备注
 */
export async function SetInvoiceRemark(data = {}) {
	const res = await request.post(
		"/api/helper/Check2Invoice/UpD_Remark",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取负责省份
 */
export async function GetPersonPersonProvinceList(data = {}) {
	const res = await request.post(
		"/api/ba/PersonGradation/PersonProvinceList",
		data
	);
	return res.data;
}




/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【出库单列表】）=>列表
 */
export async function wmsOtherOutList(data = {}) {
	const res = await request.post("/api/wms/OtherOut/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【出库单列表】）=>详情
 */
export async function wmsOtherOutInfo(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【出库单列表】）=>明细
 */
export async function wmsOtherOutDetail(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Detail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【出库单列表】）=>唯一码
 */
export async function wmsOtherOutDetailUnique(data = {}) {
	const res = await request.post("/api/wms/OtherOut/DetailUnique", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【出库单列表】）=>删除
 */
export async function wmsOtherOutDelete(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>审核
 */
export async function wmsOtherOutVerify(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Verify", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>弃审
 */
export async function wmsOtherOutUnVerify(data = {}) {
	const res = await request.post("/api/wms/OtherOut/UnVerify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>导出
 */
export async function wmsOtherOutExport(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Export", data, {
		responseType: "blob",
	});
	return res;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>导入
 */
export async function wmsOtherOutImport(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>上传出库明细
 */
export async function OtherOutImportDetail(data = {}) {
	const res = await request.post("/api/wms/OtherOut/ImportDetail", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>出库单据明细导入模板下载地址链接
 */
export async function OtherOutDownloadDetailTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/OtherOut/DownloadDetailTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>出库单据明细导入模板下载地址链接【编辑】
 */
export async function OtherOutDownloadTemplet(data = {}) {
	const res = await request.post("/api/wms/OtherOut/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>上传出入库唯一码明细
 */
export async function OtherOutImportUnique(data = {}) {
	const res = await request.post("/api/wms/OtherOut/ImportUnique", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>出库单据明细导入模板下载地址链接
 */
export async function OtherOutDownloadUniqueTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/OtherOut/DownloadUniqueTemplet",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>新增
 */
export async function OtherOutAdd(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 出入库管理=>库存调整管理（同【>出库单列表】）=>修改
 */
export async function OtherOutEdit(data = {}) {
	const res = await request.post("/api/wms/OtherOut/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 
 */
export async function GetSaleBillDetailBySBMIDs(data = {}) {
	const res = await request.post("/api/sms/SaleBill/SaleBillDetailBySBMIDs", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 
 */
export async function GetDespatchDetailByDPMIDs(data = {}) {
	const res = await request.post("/api/wms/Despatch/DespatchDetailByDPMIDs", data);
	return res.data;
}




/**
 *
 * @param {*} data // {"InvClass":"产品线"}
 * @returns 
 */
export async function GetHelperCountryMan(data = {}) {
	const res = await request.post("/api/helper/Helper/CountryMan", data);
	return res.data;
}

/**
 *
 * @param {*} data // {"InvClass":"产品线","ParentUserName":"父级（全国）销售账号"}
 * @returns 
 */
export async function GetHelperAreaMan(data = {}) {
	const res = await request.post("/api/helper/Helper/AreaMan", data);
	return res.data;
}

/**
 *
 * @param {*} data // {"InvClass":"产品线","ParentUserName":"父级（大区）销售账号"}
 * @returns 
 */
export async function GetHelperRegionMan(data = {}) {
	const res = await request.post("/api/helper/Helper/RegionMan", data);
	return res.data;
}

/**
 *
 * @param {*} data // {"InvClass":"产品线","ParentUserName":"父级（地区）销售账号"}
 * @returns 
 */
export async function GetHelperSalesMan(data = {}) {
	const res = await request.post("/api/helper/Helper/SalesMan", data);
	return res.data;
}

/**
 *
 * @param {*} data // 
 * @returns 
 */
export async function GetBackupReportList(data = {}) {
	const res = await request.post("/api/helper/BackupReport/List", data);
	return res.data;
}

/**
 *
 * @param {*} data // 批量下载
 * @returns 
 */
export async function GetBackupReportDownload(data = {}) {
	const res = await request.post("/api/helper/BackupReport/Download", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data // 获取选中的
 * @returns 
 */
export async function GetUserInventory(data = {}) {
	const res = await request.post("/api/ua/UserInfo/GetUserInventory", data);
	return res.data;
}


/**
 *
 * @param {*} data // 批量下载指标生成
 * @returns 
 */
export async function DownCustomerQuota(data = {}) {
	const res = await request.post("/api/ba/CustomerQuota/GeneratePdf", data, {
		responseType: "blob",
	});
	return res.data;
}



/**
 *
 * @param {*} data //修改合作状态
 * @returns 
 */
export async function SetCooperateStatus(data = {}) {
	const res = await request.post("/api/ba/Customer/SetCooperateStatus", data);
	return res.data;
}

/**
 *
 * @param {*} data //经销商指标->指标生成状态
 * @returns 
 */
export async function GetStatusForCustomerQuota(data = {}) {
	const res = await request.get("/api/helper/Helper/StatusForCustomerQuota", data);
	return res.data;
}



/**
 *
 * @param {*} data //发票管理--发票上报管理
 * @returns 
 */
export async function GetInvoiceRemind(data = {}) {
	const res = await request.post("/api/helper/Helper/GetInvoiceRemind", data);
	return res.data;
}

export async function NoInvoiceRemindThisMonth(data = {}) {
	const res = await request.post("/api/sms/SaleBill/NoInvoiceRemindThisMonth", data);
	return res.data;
}


/**
 *
 * @param {*} data //医院等级
 * @returns
 */
export async function GetHelperHosGrade(data = {}) {
	const res = await request.get("/api/helper/Helper/HosGrade", data);
	return res.data;
}


/**
 *
 * @param {*} data //出入库管理-今日不再提醒
 * @returns 
 */
export async function NoMoreWarningConvertRateToday(data = {}) {
	const res = await request.post("/api/wms/Despatch/NoMoreWarningConvertRateToday", data);
	return res.data;
}

/**
 *
 * @param {*} data //授权申请-新增/编辑-是否说明文件上传
 * @returns 
 */
export async function NeedUploadDocumentation(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/NeedUploadDocumentation", data);
	return res.data;
}

/**
 *
 * @param {*} data //授权申请-新增/编辑-文件上传
 * @returns 
 */
export async function UpLoadAttachmentAuthority(data = {}) {
	const res = await request.post("/api/ba/APPBusinessAuthority/UpLoadAttachment", data);
	return res.data;
}

/**
 *
 * @param {*} data // 报表=>U9账套下拉框获取
 * @returns 
 */
export async function HelperU9AccId(data = {}) {
	const res = await request.get("/api/helper/Helper/U9AccId", data);
	return res.data;
}

/**
 *
 * @param {*} data // 报表=>U9销售退回报表=>列表
 * @returns 
 */
export async function U8ReportU8SRReportList(data = {}) {
	const res = await request.post("/api/report/U8Report/U8SRReportList", data);
	return res.data;
}

/**
 *
 * @param {*} data // 报表=>U9销售退回报表=>导出
 * @returns 
 */
export async function U8ReportU8SRReportExport(data = {}) {
	const res = await request.post("/api/report/U8Report/U8SRReportExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 * 采购均价报表
 * @param {*} data
 */
export async function PurchaseAveragePriceList(data = {}) {
	const res = await request.post("/api/report/SMSReport/PurchaseAveragePrice", data);
	return res.data;
}

/**
 * 采购均价报表 导出
 * @param {*} data
 */
export async function PurchaseAveragePriceExport(data = {}) {
	const res = await request.post("/api/report/SMSReport/PurchaseAveragePriceExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 * 采购均价报表 列表导出
 * @param {*} data
 */
export async function PurchaseAveragePriceListExport(data = {}) {
	const res = await request.post("/api/report/SMSReport/PurchaseAveragePriceListExport", data, {
		responseType: "blob",
	});
	return res.data;
}

